<template>
  <FormBody
    :mode="mode"
    @submit-success="handleSubmitSuccess"
    @cancel="handleCancel"
  />
</template>

<script>
import { MODE_TYPE } from './const'
import FormBody from './formBody.vue'

const MODE_MAP = {
  create: MODE_TYPE.ADD,
  edit: MODE_TYPE.EDIT,
  copy: MODE_TYPE.COPY,
}

export default {
  name: 'EnterprisePlanForm',
  components: {
    FormBody,
  },
  data() {
    return {
      mode: '',
    }
  },
  created() {
    const { mode } = this.$route.query
    this.mode = MODE_MAP[mode] || MODE_TYPE.ADD
  },
  methods: {
    handleSubmitSuccess() {
      this.$refreshBack(true)
      this.$router.replace({ path: '/car_to_lease/enterprisePlan/list' })
    },
    handleCancel() {
      this.$refreshBack(true)
      this.$router.replace({ path: '/car_to_lease/enterprisePlan/list' })
    },
  },
}
</script>
